import { Alert } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import type { ValidConversationProps } from './valid-conversation.type'

export const ValidConversation = ({ evaluation }: ValidConversationProps) => {
  const { t } = useTranslation('screenAiCenter')

  if (!evaluation?.generalNote) {
    return (
      <Alert
        variant="warning"
        title={t('conversationShowValidConversationEmpty')}
      >
        {t('conversationShowValidConversationEmptyDescription')}
      </Alert>
    )
  }

  return (
    <Alert
      variant={evaluation?.isConversationValid ? 'success' : 'danger'}
      title={
        evaluation?.isConversationValid
          ? t('conversationShowAlertValidTitle')
          : t('conversationShowAlertInvalidTitle')
      }
    >
      {evaluation?.conversationValidationObservation ||
        t('conversationShowAlertEmptyDescription')}
    </Alert>
  )
}
